// Redirect to confirmation page after the form is sent
// source : https://contactform7.com/redirecting-to-another-url-after-submissions/
// The confirmation page need to exist in WP BO

var url = window.location.href;
var confirmationFr = window.location.origin + '/confirmation';
var confirmationEn = window.location.origin + '/en/confirmation';

document.addEventListener( 'wpcf7mailsent', function( event ) {
  if(url.indexOf("/en/") > -1) {
    location = confirmationEn;
  } else {
    location = confirmationFr;
  }
}, false );